<template>
  <div>
    <div class="title-bar-container" v-if="config" id="titleBar"
         :style="{backgroundColor: config.backgroundColor, opacity: beforeScrollOpacity, zIndex: beforeScrollIndex}">
      <div :class="[{ android: isAndroid }, 'status-bar-content', {'dp-status-bar-content': isInDianping && !isAndroid}]"></div>
      <div class="title-bar-under-status">
        <span
          class="back-icon"
          :style="{ backgroundImage: (config.backIcon ? 'url(' + config.backIcon + ')' : '')}"
          @click.stop="titleBarBackHandler"
        ></span>
        <span class="title-middle" :style="{ color: config.titleColor }">
          {{ config.title }}
        </span>
        <slot name="titleBarMiddle"></slot>
        <span
          v-if="config.rightText"
          class="right-text"
          :style="{ color: config.titleColor }"
          @click.stop="titleBarRightBtnHandler"
        >
          {{ config.rightText }}
        </span>
        <slot name="titleBarRight"></slot>
      </div>
    </div>
    <!--滚动中titleBar-->
    <div class="title-bar-container" v-if="scrollingConfig"
         :style="{backgroundColor: scrollingConfig.backgroundColor, opacity: scrollingOpacity, zIndex: scrollingIndex}">
      <div :class="[{ android: isAndroid }, 'status-bar-content', {'dp-status-bar-content': isInDianping}]"></div>
      <div class="title-bar-under-status">
        <span
          class="back-icon"
          :style="{ backgroundImage: (scrollingConfig.backIcon ? 'url(' + scrollingConfig.backIcon + ')' : '')}"
          @click.stop="titleBarBackHandler"
        ></span>
        <span class="title-middle" :style="{ color: scrollingConfig.titleColor }">
          {{ scrollingConfig.title }}
        </span>
        <slot name="scrollingTitleBarMiddle"></slot>
        <span
          v-if="scrollingConfig.rightText"
          class="right-text-scrolling"
          :style="{ color: config.titleColor }"
          @click.stop="titleBarRightBtnHandler"
        >
          {{ scrollingConfig.rightText }}
        </span>
        <slot name="scrollingTitleBarRight"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { env } from '@/common/env';
import { throttle } from '@/common/utils';

export default {
  name: 'TitleBar',
  props: {
    titleBarInfo: {
      type: Object,
      default: () => ({}),
    },
    scrollingTitleBarInfo: {
      type: Object,
      default: () => {}
    },
    // 设置状态栏主题，1为白色，0为黑色。
    setStatusBarColor: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      beforeScrollOpacity: 1,
      beforeScrollIndex: 1000,
      scrollingOpacity: 0,
      scrollingIndex: 999,
    };
  },
  computed: {
    isAndroid() {
      return env.system === 'android';
    },
    isInDianping() {
      return env.isInDianping;
    },
    config() {
      return {
        backgroundColor: '#fff',
        backIcon:
          'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/white-back-icon-20221105.png',
        titleColor: 'rgba(0,0,0,0.90)',
        title: '',
        rightText: '',
        ...this.titleBarInfo
      };
    },
    scrollingConfig() {
      return this.scrollingTitleBarInfo;
    }
  },
  mounted() {
    this.$bridge.navBarHidden();
    // 兼容点评App
    if (env.isInDianping) {
      KNB && KNB.setLLButton({
        icon: '',
        handle: () => {
          this.$bridge.closePage();
        },
      });
      document.title = '';
    }
    // 不传scrollingBgColorbgColor默认导航栏不随着滚动发生变化
    if (this.scrollingConfig) {
      window.addEventListener('scroll', this.changeTitleBar, true);
    }
    this.$bridge.setBounces(0);
    this.$bridge.setStatusBarStyle(this.setStatusBarColor);
    this.$bridge.subscribe('appear', () => {
      this.$bridge.navBarHidden();
      // 兼容点评App
      if (env.isInDianping) {
        KNB && KNB.setLLButton({
          icon: '',
          handle: () => {
            this.$bridge.closePage();
          },
        });
        document.title = '';
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.changeTitleBar, true);
  },
  methods: {
    titleBarBackHandler() {
      this.$emit('back');
    },
    titleBarRightBtnHandler() {
      throttle(null, () => {
        this.$emit('rightHandler');
      }, 500)();
    },
    changeTitleBar() {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      const whiteOpacity = Math.min((scrollTop / 44).toFixed(2), 1);
      this.beforeScrollOpacity = 1 - whiteOpacity;
      this.scrollingOpacity = whiteOpacity;
      if (this.scrollingOpacity > this.beforeScrollOpacity) {
        this.scrollingIndex = 1000;
        this.beforeScrollIndex = 999;
        this.$bridge.setStatusBarStyle(0);
      } else {
        this.scrollingIndex = 999;
        this.beforeScrollIndex = 1000;
        this.$bridge.setStatusBarStyle(this.setStatusBarColor);
      }
    }
  },
};
</script>
<style lang='less' scoped>
.title-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  .status-bar-content {
    width: 100%;
    height: calc(env(safe-area-inset-top));
    height: calc(constant(safe-area-inset-top));
    &.android {
      height: 0;
    }
  }
  .dp-status-bar-content {
    height: calc(env(safe-area-inset-top) - 88px);
    height: calc(constant(safe-area-inset-top) - 88px);
  }
  .title-bar-under-status {
    height: 88px;
    line-height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 24px;
    padding-right: 24px;
    .back-icon {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: inline-block;
      width: 40px;
      height: 40px;
      vertical-align: middle;
      -webkit-tap-highlight-color: transparent; //去掉点击时的背景色
    }
    .title-middle {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 36px;
      color: rgba(0,0,0,0.90);
      text-align: center;
      font-weight: 500;
      font-family: PingFang-SC-Medium;
      white-space: nowrap;
    }
    .right-text {
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #fff;
      letter-spacing: 0;
      text-align: right;
      line-height: 32px;
    }
    .right-text-scrolling {
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #222222;
      letter-spacing: 0;
      text-align: right;
      line-height: 32px;
    }
  }
}
</style>
